import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Picture from '@/image/hotel/magazine_top.jpg';
import { StorySlider } from '@/components/Magazine/StorySlider';
import { Explore } from '@/components/Magazine/Explore';
import { Magazine } from '@/components/Magazine/magazine';
import { MenuBar } from '@/components/common/MenuBar';
import { FooterItems } from '@/components/common/FooterItems';
import { DetileTextImage } from '@/components/common/DetileTextImage';
import { DownArrowIcon } from '@/assets/DownArrowIcon';

export const MagazinePage: React.FC = () => {
  // URL の先頭セグメントを取得して言語判定
  const location = useLocation();
  const langSegment = location.pathname.split('/')[1];
  const language = langSegment === 'en' ? 'en' : 'ja';

  // Meta description と OGP description を言語で分岐
  const metaDescription =
    language === 'en'
      ? 'The Apartment Hotel’s neighborhood guide introduces places from city residents and long-term visitors, showcasing the real Tokyo.'
      : 'ザ・アパートメントホテルによるネイバーフッドガイドでは、実際に東京に住む人や長期滞在する人が、リアルな東京を探索するためのネイバーフッドプレイスを紹介する。';

  // 英語テキスト
  const textEn = `
    Thoughtfully placed in the city’s most vibrant neighborhoods.
    Our spaces are more than a temporary home—they’re a reflection
    of the life flowing through the streets of Shimokitazawa,
    Nakameguro, and beyond.
  `;

  // 日本語テキスト
  const textJa = `
    観光ガイドに載っていないローカルな場所を発見し、本当のネイバーフッドを知ることは意外と難しい。
    ザ・アパートメントホテルによるネイバーフッドガイドでは、実際に東京に住む人や長期滞在する人が、
    本当の意味でリアルな東京を探索するためのネイバーフッドプレイスを紹介する。
  `;

  return (
    <>
      <Helmet>
        {/* Meta Tags */}
        <title>Neighborhood guide</title>
        <meta name="description" content={metaDescription} />

        {/* OGP Tags */}
        <meta property="og:title" content="Neighborhood guide" />
        <meta property="og:description" content={metaDescription} />
        {/* OGP_Image ※3/19に完成予定。画像URLは更新してください。 */}
        <meta property="og:image" content="URL_OF_OGP_IMAGE" />
        <meta property="og:type" content="website" />
      </Helmet>
      <MenuBar
        leftText="Left Link"
        rightText="Right Link"
        leftLink="/path-to-left-link"
        rightLink="/path-to-right-link"
      >
        <div className="bg-whiteYellow relative w-full">
          <DetileTextImage
            imageSrc={Picture}
            verticalText="Neighborhood Guide"
            bottomTextPosition="center"
            bottomText={
              <div className="text-center max-md:mt-14 md:mr-5">
                <p className="text-xs">
                  {language === 'en'
                    ? 'Our Neighborhoods'
                    : 'Exploring the Neighborhoods'}
                </p>
                <div className="py-3 max-md:px-2 md:px-8 text-base">
                  {language === 'en' ? textEn : textJa}
                </div>
              </div>
            }
            imageTall={true}
          />

          <div className="px-4">
            <div className="mb-[6.25rem]">
              <StorySlider />
            </div>
            <div className="mb-[6.25rem] flex justify-center">
              <Explore />
            </div>
            <div>
              <Magazine />
            </div>
            <FooterItems />
          </div>
        </div>
      </MenuBar>
    </>
  );
};
